import { PersonBenefits } from '@esportal/portal-service/src/models/benefits';
import { GetPersonUser } from '@esportal/portal-service/src/models/portal';
import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import { BonoPosventaCard } from './bono-posventa/components/card/bono-posventa-card';
import { HuchaVentaCard } from './hucha-venta/components/card/hucha-venta-card';
import { useHuchaValues } from './shared/hooks/use-hucha-values';
import { HuchaPosventaValues, HuchaVentaValues } from './shared/models/hucha-values';

const StyledHuchaContainer = styled.div`
	display: flex;
	align-items: start;
	flex-wrap: wrap;
	gap: var(--size-dynamic0100);

	& > div {
		flex: 1;
	}

	@media (min-width: 960px) {
		flex-wrap: nowrap;
	}
`;

export const HuchaContainer = ({
	userData,
	personBenefits,
}: {
	userData: GetPersonUser | null;
	personBenefits: PersonBenefits;
}) => {
	const huchaVentaValues = useHuchaValues(userData, personBenefits, 'venta') as HuchaVentaValues;
	const huchaPosventaValues = useHuchaValues(userData, personBenefits, 'posventa') as HuchaPosventaValues | null;

	if (!huchaVentaValues && !huchaPosventaValues) {
		return null;
	}

	return (
		<>
			<StyledHuchaContainer>
				{huchaVentaValues && (
					<HuchaVentaCard huchaValues={huchaVentaValues} bonoPosventaExists={!!huchaPosventaValues} />
				)}
				{huchaPosventaValues && <BonoPosventaCard huchaValues={huchaPosventaValues} />}
			</StyledHuchaContainer>
		</>
	);
};
